import { c as _c } from "react/compiler-runtime";
import { LabelWithHelp } from "@components/common/label-with-help";
import { MemberAutocomplete } from "@components/common/member-autocomplete/member-autocomplete";
import { Text } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { GroupMembershipSection } from "@pages/project-details/project-overview/change-management/group-membership-section";
import { ManagerSeatSection } from "@pages/project-details/project-overview/change-management/manager-seat-section";
/**
 * Lets the user choose the new project manager of a project. An admin of the workspace can choose
 * any of its members or invite somebody new by email, and is told when they join the group or get a
 * Sphere XG seat on the way. Anybody else can only choose the group and project managers of the
 * group, as the field tells them.
 */
export function ManagerSelection(t0) {
  const $ = _c(36);
  const {
    isWorkspaceAdminView,
    candidates,
    memberNotes,
    selectedMember,
    onSelectedMemberChange,
    isDisabled,
    groupName,
    groupMembershipChange,
    groupRole,
    onGroupRoleChange,
    seat,
    isSeatChecked,
    onSeatCheckedChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: 2
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isDisabled) {
    t2 = <LabelWithHelp title="Manager" isDisabled={isDisabled} />;
    $[1] = isDisabled;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      gap: 0.5
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== candidates || $[5] !== isDisabled || $[6] !== isWorkspaceAdminView || $[7] !== memberNotes || $[8] !== onSelectedMemberChange || $[9] !== selectedMember) {
    t4 = <MemberAutocomplete members={candidates} memberNotes={memberNotes} selectedMember={selectedMember} onOptionChange={onSelectedMemberChange} isDisabled={isDisabled} canInviteByEmail={isWorkspaceAdminView} shouldShowAllOptions={true} placeholder="Choose who can manage this project..." />;
    $[4] = candidates;
    $[5] = isDisabled;
    $[6] = isWorkspaceAdminView;
    $[7] = memberNotes;
    $[8] = onSelectedMemberChange;
    $[9] = selectedMember;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== isWorkspaceAdminView) {
    t5 = !isWorkspaceAdminView && <Text variant="bodyS" sx={{
      color: "text.secondary"
    }}>Only group managers and project managers of this group are listed</Text>;
    $[11] = isWorkspaceAdminView;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <Stack sx={t3}>{t4}{t5}</Stack>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t2 || $[17] !== t6) {
    t7 = <Stack>{t2}{t6}</Stack>;
    $[16] = t2;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== groupMembershipChange || $[20] !== groupName || $[21] !== groupRole || $[22] !== isWorkspaceAdminView || $[23] !== onGroupRoleChange || $[24] !== selectedMember) {
    t8 = isWorkspaceAdminView && selectedMember && groupMembershipChange !== "none" && <GroupMembershipSection selectedMember={selectedMember} change={groupMembershipChange} groupName={groupName} role={groupRole} onRoleChange={onGroupRoleChange} />;
    $[19] = groupMembershipChange;
    $[20] = groupName;
    $[21] = groupRole;
    $[22] = isWorkspaceAdminView;
    $[23] = onGroupRoleChange;
    $[24] = selectedMember;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== isSeatChecked || $[27] !== isWorkspaceAdminView || $[28] !== onSeatCheckedChange || $[29] !== seat || $[30] !== selectedMember) {
    t9 = isWorkspaceAdminView && selectedMember && seat.isSeatNeeded && <ManagerSeatSection selectedMember={selectedMember} seat={seat} isChecked={isSeatChecked} onChange={onSeatCheckedChange} />;
    $[26] = isSeatChecked;
    $[27] = isWorkspaceAdminView;
    $[28] = onSeatCheckedChange;
    $[29] = seat;
    $[30] = selectedMember;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  let t10;
  if ($[32] !== t7 || $[33] !== t8 || $[34] !== t9) {
    t10 = <Stack sx={t1}>{t7}{t8}{t9}</Stack>;
    $[32] = t7;
    $[33] = t8;
    $[34] = t9;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  return t10;
}